import { Component } from '@angular/core';

@Component({
  selector: 'app-associations',
  templateUrl: './associations.component.html',
  styleUrl: './associations.component.scss'
})
export class AssociationsComponent {

}
